import { render, staticRenderFns } from "./Pacjent.vue?vue&type=template&id=2abb922e&"
import script from "./Pacjent.vue?vue&type=script&lang=js&"
export * from "./Pacjent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports